export const myTimeTranslationsEn = {
  MY_TIME_NO_UNCLOSED_PERIOD: "There is no unclosed period!",
  MY_TIME_USER_APPROVAL_ERROR: "The acknowledgement was failed.",
  MY_TIME_USER_APPROVAL_SUCCESS: "The acknowledgement was successful.",
  MY_TIME_FORCE_APPROVAL_ALL_ERROR: "Group month closing was failed.",
  MY_TIME_FORCE_APPROVAL_ALL_SUCCESS: "Group month closing was successful.",
  MY_TIME_FORCE_APPROVAL_REMOVE_ERROR: "The user's working schedule was revoked failed.",
  MY_TIME_FORCE_APPROVAL_REMOVE_SUCCESS: "The user's working schedule was revoked successfully.",
  MY_TIME_FORCE_APPROVAL_ERROR: "Failed to accept user's working schedule.",
  MY_TIME_FORCE_APPROVAL_SUCCESS: "User's working schedule successfully accepted.",
  MY_TIME_APPROVAL_USER_CLOSE_ERROR: "Failed to accept the working schedule.",
  MY_TIME_UNLOCK_CLOSE_MONTH_INFO: "Are you sure you want to unlock closed month?",
  MY_TIME_UNLOCK_CLOSE_MONTH_TITLE: "Unlock closed month",
  MY_TIME_CONFIRM_GROUP_CLOSE_MONTH_TEXT_RESPONSIBILITY: "Aware of my responsibility as an employer, I declare that, prior to accepting the position as an employer, I have fulfilled my legal obligation to inform the employee in the manner customary and generally known locally.",
  MY_TIME_WORKING_SCHEDULE_ACCEPTANCE_ERROR: "An error occurred while acknowledging the working schelude allowed!",
  MY_TIME_WORKING_SCHEDULE_ACCEPT: "Working schedule allowed",
  MY_TIME_CONFIRM_GROUP_CLOSE_MONTH_TEXT: "Are you sure to closed month to selected user(s)?",
  MY_TIME_FORCE_APPROVAL: "Group closed month",
  MY_TIME_CLOSED_MONTH: "Closed month",
  MY_TIME_CLOSE_MONTH: "Close month",
  MY_TIME_APPROVED: "Approved",
  MY_TIME_ACKNOWLEDGED: "Acknowledged",
  MY_TIME_MY_EXAMINED_USERS: "My examined users",
  MY_TIME_APPROVAL_USER_CLOSE_SUCCESS:
    "The user has successfully closed the MyTime approval period.",
  MY_TIME_APPROVAL_ALLOWED_INFO:
    "The employee confirms their acknowledgement of their assignment and accepts the working time statement at the end of the period.",
  MY_TIME_APPROVAL_ALLOWED: "MyTime approval enabled",
  MY_TIME_NOT_APPROVED_TIMESHEETS_WO_EXAMINER:
    "Unclosed months without reviewer",
  MY_TIME_NOT_APPROVED_TIMESHEETS: "Unclosed months",
  MY_TIME_NOT_AUTHORIZED_TIMESHEETS: "Not authorized timesheets",
  MY_TIME_NOT_AUTHORIZED_TIMESHEETS_WO_EXAMINER:
    "Not authorized timesheets without reviewer",
  MY_TIME_DASHBOARD: "MyTime dashboard",
  MY_TIME_ACKNOWLEDGE: "I acknowledge",
  MY_TIME_EMPLOYEE_SCHEDULE_PAGE_TITLE: "My reports details and requests",
  MY_TIME_EXCEEDS_STAND_BY_INTERVALL:
    "Stand by call recording is only allowed during standby time.",
  MY_TIME_BALANCE: "Balance",
  MY_TIME_CURRENT_BALANCE: "Current balance",
  MY_TIME_OPENING_BALANCE: "Opening balance",
  MY_TIME_CLOSING_BALANCE: "Closing balance",
  MY_TIME_AVAILABLE_WORKING_BALANCE: "Available working balance",
  MY_TIME_UNEXAMINED_REQUESTS: "Open, unexamined requests",
  MY_TIME_ACCEPTED_OVERTIME: "Accepted overtime",
  MY_TIME_VOLUNTARY_OVERTIME: "Voluntary overtime",
  MY_TIME_ON_CALL: "On Call",
  MY_TIME_WORKING_TIME: "Working time",
  MY_TIME_STAND_BY: "Stand-by",
  MY_TIME_WORKING_TIME_ITEM: "Sub-item",
  MY_TIME_ZERO_DURATION_NOT_ALLOWED: "Start and end time cannot be the same!",
  MY_TIME_NEGATIVE_DURATION_NOT_ALLOWED: "End time cannot be earlier than start time!",
  MY_TIME_LEAVE: "Leave",
  MY_TIME_HOMEOFFICE: "Home Office",
  MY_TIME_STAND_BY_CALL: "Standby call",
  MY_TIME_OVERTIME: "Overtime",
  MY_TIME_PERSONAL_LEAVE: "Personal leave",
  MY_TIME_PERSONAL_LEAVE_REQUIRES_WORKING_TIME: "Personal leave can only be recorded within working hours!",
  MY_TIME_OVERTIME_NOT_ALLOWED_TEXT:
    "It is not allowed to create a request on this day!",
  MY_TIME_ONE_OVERTIME_ALLOWED_TEXT:
    "Already there is an overtime on this day!",
  MY_TIME_USER_GUIDE: "MyTime user manual",
  MY_TIME_EXAMINER_GUIDE: "MyTime examiner manual",
  MY_TIME_ADMIN_GUIDE: "MyTime administrator manual",
  MY_TIME_DATA_NOT_CHANGED: "Data not changed!",
  MY_TIME_CLOSE_RECORDING_PERIOD_SUCCEEDED: "Close recording month succeeded",
  MY_TIME_CLOSE_RECORDING_PERIOD_FAILED: "Close recording month failed",
  MY_TIME_CONFIRM_CLOSE_MONTH_TITLE: "Close month confirmation",
  MY_TIME_CONFIRM_CLOSE_MONTH_TEXT: "Are you sure to close the month?",
  MY_TIME_WORK_ORDER: "Work order",
  MY_TIME_CATEGORY: "Category",
  MY_TIME_NO_TIME_PERIOD: "None",
  MY_TIME_NO_TIME_PERIOD_INFO:
    "The employee can submit a request exactly by the minute. (e.g. 08:00, 08:05, ect.)",
  MY_TIME_10_MINUTES_TIME_PERIOD: "10 minutes",
  MY_TIME_10_MINUTES_TIME_PERIOD_INFO:
    "The start and end time of the request can be entered in 10-minute intervals. (e.g. 08:00, 08:10, ect.)",
  MY_TIME_30_MINUTES_TIME_PERIOD: "30 minutes",
  MY_TIME_30_MINUTES_TIME_PERIOD_INFO:
    "The start and end time of the request can be entered in 30-minute intervals. (e.g. 08:00, 08:30, ect.)",
  MY_TIME_TIME_PERIOD_SETTINGS: "Time period settings",
  MY_TIME_APPROVE_ALL_REQUESTS_ALLOWED: "Approve all requests enabled",
  MY_TIME_APPROVE_ALL_REQUESTS_ALLOWED_INFO:
    "The admin can approve all requests.",
  MY_TIME_CHANGE_ALLOWED_INFO: "The employee can change the working time.",
  MY_TIME_CHANGE_ALLOWED: "Change working time",
  MY_TIME_CHANGE_WORKING_TIME_ALLOWED: "Working time change",
  MY_TIME_CHANGE_WORKING_TIME_ALLOWED_INFO:
    "The employee can submit a modification regarding their working hours.",
  MY_TIME_SHOW_BALANCE_FRAME_ALLOWED: "Show balance card",
  MY_TIME_SHOW_BALANCE_FRAME_ALLOWED_INFO:
    "Display the balance card on the employee schedule page.",
  MY_TIME_PERIOD_NOT_APPROPRIATE:
    "The time entered does not match the settings.",
  MY_TIME_WORKING_SCHEDULE: "Working schedule",
  MY_TIME_REQUEST_CREATE_SUCCEEDED: "The request was created successfully",
  MY_TIME_REQUEST_CREATE_FAILED: "Request creation failed",
  MY_TIME_REQUEST_DELETE_SUCCEEDED: "The request was successfully withdrawn",
  MY_TIME_REQUEST_DELETE_FAILED:
    "The withdrawal of the request was unsuccessful",
  MY_TIME_REJECT_SUCCEEDED: "The request was successfully rejected",
  MY_TIME_REJECT_FAILED: "Rejection of the request was unsuccessful",
  MY_TIME_APPROVE_SUCCEEDED: "The request has been accepted successfully",
  MY_TIME_APPROVE_FAILED: "Acceptance of the request failed",
  MY_TIME_ALL_APPROVE_SUCEEDED: "The items have been accepted successfully",
  MY_TIME_EXCEEDS_WEEKLY_WORKTIME_LIMIT: "Weekly worktime exceeded the limits",
  MY_TIME_EXCEEDS_WEEKLY_VOLUNTARY_OVERTIME_LIMIT:
    "Voluntary overtime on the week exceed the limit",
  MY_TIME_EXCEEDS_DAILY_WORKTIME_LIMIT:
    "Normal hours + overtime exceed 12 hours",
  MY_TIME_PAID_HOLLIDAY: "Paid holliday",
  MY_TIME_WORKDAY: "Workday",
  MY_TIME_REST_DAY: "Rest day",
  MY_TIME_OTHER: "Other",
  MY_TIME_CONSCRIPTIONS: "Conscriptions",
  MY_TIME_OVERTIMES: "Overtimes",
  MY_TIME_REPORTS_CHANGES: "Reports changes",
  MY_TIME_REQUEST_NOT_FOUND: "Request not found!",
  MY_TIME_ACTIVE_REQUESTS: "Active requests",
  MY_TIME_TYPE: "MyTime type",
  MY_TIME_ADMISSION: "Admission",
  MY_TIME_PERIOD_TEXT: "MyTime period",
  MY_TIME_RECORDING_PERIOD: "Recording period",
  MY_TIME_REQUESTS: "MyTime Requests",
  MY_TIME_MY_ADMISSION: "My admission",
  MY_TIME_MY_WORK_TIME_REPORTS: "Reports",
  MY_TIME_WORK_TIME_FRAME: "Work time frame",
  MY_TIME_WORKED_TIME_FRAME: "Worked time frame",
  MY_TIME_FRAME_PERIOD: "Work time frame period",
  MY_TIME_CLOSING_PERIOD: "Closing period",
  MY_TIME_MAX_OVERTIME_IN_HOUR: "Max overtime in hour",
  MY_WORK_TIME_REPORTS: "Reports",
  MY_TIME_ABSENCE: "Absence",
  MY_TIME_APPROVAL_ALLOWED_BY_THE_EXAMINER: "Employee schedule approval",
  MY_TIME_APPROVAL_ALLOWED_BY_THE_EXAMINER_INFO: "The examiner is allowed to approve the employee's schedule.",
  MY_TIME_FORCE_AUTHORIZATION: "Group authorization",
  MY_TIME_AUTHORIZATION: "Authorization",
  MY_TIME_AUTHORIZED: "Authorized",
  MY_TIME_AUTHORIZATION_CONFIRMATION: "Authorization Confirmation",
  MY_TIME_AUTHORIZATION_CONFIRMATION_INFO: "Are you sure you want to approve the selected employee(s)?",
};
